module.exports = __webpack_public_path__ + "media/images/arrow-r@2x-a0a7c6c84761e38cd360ddada2405897.png";